import { useState, useEffect } from "react";
import { fetchContent } from "../../services/parameter.service";

const useBannerTrabajeConNosotros = () => {
  const [bannerTrabajeConNosotros, setBannerTrabajeConNosotros] = useState({});
  const [isLoadingTrabajeConNosotros, setIsLoadingTrabajeConNosotros] = useState(false);

  const getBannerTrabajeConNosotros = async () => {
    setIsLoadingTrabajeConNosotros(true);

    try {
      const responseContent = await fetchContent("trabajeconnosotros");
      setBannerTrabajeConNosotros(responseContent.data.list);

      setIsLoadingTrabajeConNosotros(false);
    } catch (error) {
      console.error(" ERROR EN useBannerTrabajeConNosotros --> ", error);
    }
  };

  useEffect(() => {
    getBannerTrabajeConNosotros();
  }, []);

  return {
    bannerTrabajeConNosotros 
  };
};

export default useBannerTrabajeConNosotros;
